import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Redirect, useHistory, Link } from 'react-router-dom';
import { Box, Grid, Typography, TextField, Button } from '@mui/material';
import { Google } from '@mui/icons-material';

// Import Firebase Google sign-in helper
import { signInWithGoogle, signInWithEmail } from '../firebase'; // You need to implement signInWithEmail
import { googleLogin, emailLogin } from "../actions/auth";

const Login = ({ isAuthenticated, googleLogin, emailLogin }) => {
    let history = useHistory();

    const [fromHome, setFromHome] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        setFromHome(history.location.state);
    }, [history]);

    const onChange = (e) => {
        if (e.target.name === 'email') setEmail(e.target.value);
        if (e.target.name === 'password') setPassword(e.target.value);
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        try {
            const user = await signInWithEmail(email, password);
            emailLogin(user);
            setError('');
        } catch (err) {
            setError('Invalid email or password. Please try again.');
            console.log('Email sign-in error:', err);
        }
    };

    const handleGoogleLogin = async () => {
        try {
            const user = await signInWithGoogle();
            googleLogin(user);
            setError('');
        } catch (err) {
            setError('Google sign-in failed. Please try again.');
            console.log('Google sign-in error:', err);
        }
    };

    if (isAuthenticated) {
        if (history.length > 3) {
            history.goBack();
            return null;
        } else {
            return <Redirect to='/' />;
        }
    }

    return (
        <Box sx={{ mt: '10px' }}>
            <Grid container sx={{ display: 'flex', justifyContent: 'center', backgroundColor: '#F2F2F2', p: 2 }}>
                <Grid item xs={4} sm={4}>
                    <Typography component="h1" variant="h5" align="center">
                        Sign In
                    </Typography>
                    {error && (
                        <Typography color="error" align="center" sx={{ mt: 1 }}>
                            {error}
                        </Typography>
                    )}
                    <form onSubmit={onSubmit}>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            id="email"
                            label="Email"
                            name="email"
                            value={email}
                            onChange={onChange}
                            required
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            name="password"
                            label="Password"
                            type="password"
                            id="password"
                            value={password}
                            onChange={onChange}
                            required
                        />
                        <Button variant="contained" type="submit" fullWidth sx={{ mt: 2 }}>
                            Login
                        </Button>
                    </form><br />
                    <Typography align="center" sx={{ mt: 2 }}>
                        Don't have an account? <Link to='/signup'>Sign Up</Link>
                    </Typography><br />
                    <Typography align="center">
                        Forgot your Password? <Link to='/reset-password'>Reset Password</Link>
                    </Typography>
                </Grid>
                <Grid item xs={2} sm={2}></Grid>
                <Grid item xs={3} sm={3}>
                    <Button
                        variant="contained"
                        startIcon={<Google />}
                        style={{ backgroundColor: '#4285F4', color: 'white' }}
                        onClick={handleGoogleLogin}
                    >
                        Sign in with Google
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
};

const mapStateToProps = (state) => ({
    isAuthenticated: state.auth.isAuthenticated,
    user: state.auth.user,
});

export default connect(mapStateToProps, { googleLogin, emailLogin })(Login);